import { FirebaseOptions } from "firebase/app";

export const VAPID_KEY = process.env.REACT_APP_VAPID_KEY || '';

export const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG || '') as FirebaseOptions;
